// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase:{
    apiKey: "AIzaSyDp6sdGrb1q48-dP2hIjSSYXMvfYN7G01E",
    authDomain: "clientpanelprod-c464a.firebaseapp.com",
    databaseURL: "https://clientpanelprod-c464a.firebaseio.com",
    projectId: "clientpanelprod-c464a",
    storageBucket: "clientpanelprod-c464a.appspot.com",
    messagingSenderId: "223442029243"
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts